module.exports = __webpack_public_path__ + "static/media/Fig-4-2.9819e9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Fig-4-2.png
// module id = 679
// module chunks = 0